import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { StatusService } from '@core/services/status.service';
import { State } from '@shared/interfaces/state';

@Component({
  selector: 'app-status-edit',
  templateUrl: './status-edit.component.html'
})
export class StatusEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public state: State;
  public statusList: Array<State> = [];
  public stateForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private statusService: StatusService,
    public dialogRef: MatDialogRef<StatusEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.status.title;
    this.stateForm = new FormGroup({
      name: new FormControl('', Validators.required)
    });
    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.state = this.data.item;
      this.stateForm.addControl(
        'id',
        new FormControl(this.state.id, [Validators.required])
      );
      this.stateForm.patchValue({
        id: this.state.id,
        name: this.state.name
      });
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      this.constants.title =
        this.appConfig.LANG.title.add + ' ' + this.constants.title;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.stateForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.statusService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
